import React from 'react';
import { Menu, Input, Button, MenuItem, Icon, Table } from 'semantic-ui-react';
import classNames from 'classnames';
import { useField } from '../../hooks';
import api from '../../api';
import Config from '../../constants/Config';
import SettlementManageModal from './SettlementManageModal';
import styles from './SettlementManage.module.scss';
import moment from 'moment';

const settlementManage = React.memo(() => {
  const [value, handleFieldChange] = useField('');
  const [currentSkip, setCurrrentSkip] = React.useState(1);
  const [isOpen, setIsOpen] = React.useState(false);
  const [listObj, setListObj] = React.useState({
    list: [],
    total: 0,
  });

  const init = React.useCallback(() => {
    api
      .getSettlementManageLists({
        limit: Config.AONNOUCEMENT_LIMIT,
        skip: currentSkip - 1,
        search: value,
      })
      .then((res) => {
        setListObj({ list: res.item, total: res.total });
      });
  }, [currentSkip, value]);

  const again = () => {
    setCurrrentSkip(1);
    setListObj({ list: [], total: 0 });
    init();
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      again();
    }
  };

  React.useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSkip]);

  return (
    <div className={styles.app}>
      {isOpen && <SettlementManageModal onInit={again} onClose={onClose} />}
      <div className={styles.table}>
        <div className={styles.box}>
          <Input
            value={value}
            onChange={handleFieldChange}
            action={{
              content: '搜索',
              onClick: again,
            }}
            onKeyPress={handleKeyPress}
            placeholder="姓名/推广码"
          />
          <Button
            positive
            content="新增结算"
            onClick={() => {
              setIsOpen(true);
            }}
          />
        </div>
        <Table celled unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={2}>姓名</Table.HeaderCell>
              <Table.HeaderCell width={2}>推广码</Table.HeaderCell>
              <Table.HeaderCell width={2}>已结算金额（¥）</Table.HeaderCell>
              <Table.HeaderCell width={2}>待结算金额（¥）</Table.HeaderCell>
              <Table.HeaderCell width={2}>最近一次结算时间</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {!!listObj.list.length &&
              listObj.list.map((item) => (
                <Table.Row key={item.id}>
                  <Table.Cell>{item.name}</Table.Cell>
                  <Table.Cell>{item.promotionCode}</Table.Cell>
                  <Table.Cell>{item.settlementAmount}</Table.Cell>
                  <Table.Cell>{item.pendingSettlementAmount}</Table.Cell>
                  <Table.Cell>
                    {item.lastSettlementTime &&
                      moment(item.lastSettlementTime).add(8, 'hours').format('YYYY-MM-DD HH:mm:ss')}
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="5">
                <Menu floated="right" pagination>
                  <MenuItem
                    as="a"
                    icon
                    onClick={() => {
                      setCurrrentSkip((pre) => {
                        if (pre <= 1) {
                          return 1;
                        }
                        return pre - 1;
                      });
                    }}
                  >
                    <Icon name="chevron left" />
                  </MenuItem>
                  {Array.from({ length: listObj.total }, (_, index) => (
                    <MenuItem
                      as="a"
                      key={index}
                      className={classNames(index + 1 === currentSkip && styles.menuItemActive)}
                      onClick={() => {
                        setCurrrentSkip(index + 1);
                      }}
                    >
                      {index + 1}
                    </MenuItem>
                  ))}
                  <MenuItem
                    as="a"
                    icon
                    onClick={() => {
                      setCurrrentSkip((pre) => {
                        if (pre + 1 >= listObj.total) {
                          return listObj.total;
                        }
                        return pre + 1;
                      });
                    }}
                  >
                    <Icon name="chevron right" />
                  </MenuItem>
                </Menu>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    </div>
  );
});

export default settlementManage;
